import React from "react";
import "./earlierIntakeChoice.css";

/**
 * WT-231: shown when a patient opens one program while another is already at
 * product selection or checkout in this tab. A plain choice, not an error:
 * nothing is lost either way, because the earlier intake stays saved.
 */
export default function EarlierIntakeChoice({
  choice,
  busy = false,
  onContinue,
  onStart,
}) {
  if (!choice) return null;
  const earlierName = choice.earlier?.name || "your earlier intake";
  const requestedName = choice.requested?.name || "this treatment";
  return (
    <section
      className="earlier-intake-choice"
      aria-labelledby="earlier-intake-choice-title"
    >
      <h2 id="earlier-intake-choice-title">You have an intake in progress</h2>
      <p>
        You started <strong>{earlierName}</strong> earlier. Pick up where you
        left off, or start <strong>{requestedName}</strong>. Your earlier
        progress stays saved either way.
      </p>
      <div className="earlier-intake-choice-actions">
        <button type="button" disabled={busy} onClick={onContinue}>
          Continue your earlier intake
        </button>
        <button
          type="button"
          className="earlier-intake-choice-secondary"
          disabled={busy}
          onClick={onStart}
        >
          Start this one
        </button>
      </div>
    </section>
  );
}
